<template>
  <v-row class="panel-section-header">
    <h4>{{ $t('components.panelConfiguration.truckLoading') }}</h4>
  </v-row>
  <v-row class="panel-proposition-content">
    <p>{{ getTotalPanels(wallTypes) }} {{ $t('functionalities.panelEstimator.fullPanels') }}</p>
    <div style="margin: 5px;"
      :style="{ width: '10px', height: '10px', backgroundColor: '#C79467' }">
    </div>
  </v-row>
  <v-row class="panel-proposition-content">
    <p>{{ pannelPortions.length }} {{ $t('functionalities.panelEstimator.irregularPanels') }}</p>
    <div style="margin: 5px;"
      :style="{ width: '10px', height: '10px', backgroundColor: '#70451F' }">
    </div>
  </v-row>
</template>

<script setup>


defineProps({
  getTotalPanels: Function,
  wallTypes: Array,
  pannelPortions: Array,
  width: Number,
  length: Number
});
</script>

<style scoped>
@import '@/assets/styles/components/panelCountEstimator/PanelizationPropositionByType.css';
@import '@/assets/styles/components/panelCountEstimator/TruckDimensions.css';
</style>